import * as actionTypes from '../actions/actionTypes'

const initialState = {
  loginDetails: {
    isLoginSuccessful: false,
    data: {},
    isLoading: false,
    isError: false
  }
}

const authReducer = (state = initialState, action = {}) => {
  const newState = { ...state }

  switch (action.type) {
    case actionTypes.AZURE_LOGIN:
      return { ...newState, loginDetails: { ...newState.loginDetails, isLoading: true } }

    case actionTypes.AZURE_LOGIN_SUCCESS:
      sessionStorage.setItem('userInfo', JSON.stringify(action.payload))
      return { ...newState, loginDetails: { data: { ...action.payload }, isLoading: false, isError: false, isLoginSuccessful: true } }

    case actionTypes.AZURE_LOGIN_FAILURE:
      return { ...newState, isError: true, isLoginSuccessful: false }

    case actionTypes.AZURE_LOGOUT:
      return { ...newState }

    case actionTypes.AZURE_LOGOUT_SUCCESS:
      window.sessionStorage.clear()
      return { ...initialState }

    case actionTypes.AZURE_LOGOUT_FAILURE:
      return { ...newState }

    default:
      return { ...newState }
  }
}

export default authReducer
